export const sortOptions = [
    { value: 'name', label: 'Название' },
    { value: 'manufacturer', label: 'Производитель' },
    { value: 'price', label: 'Цена' },
    { value: 'brand', label: 'Бренд' },
];
